<ng-container *transloco="let t">
	<vex-page-layout mode="card">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div class="mt-4">
				<h1 class="title mt-0 mb-1">{{ t('footer.privacy') }}</h1>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content @stagger style="margin-bottom: 10px" vexContainer>
			@if (finishedLoading) {
				<div @fadeInUp class="card p-6" style="margin-top: 20px">
					<div [innerHTML]="privacy?.value" class="privacy"></div>
					<div class="vc_empty_space" style="height: 32px">
						<span class="vc_empty_space_inner">
							<span class="empty_space_image"></span>
						</span>
					</div>
				</div>
			}
		</vex-page-layout-content>
	</vex-page-layout>
</ng-container>
